// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__2gVdI","rootCenter":"LoadMoreObserver_rootCenter__2-Ygx","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__38NJ0"};